"use strict";
import { createContext } from "react";
export const HostModuleContext = createContext(null);
export const OwnerModuleContext = createContext(null);
function noOp() {
}
function identity(val) {
  return () => val;
}
export const ShellContext = createContext({
  rootPath: "/",
  moduleRootPath: "/",
  rootModule: null,
  modules: [],
  incrementLoadingCount: noOp,
  decrementLoadingCount: noOp,
  getChannelSubscriptions: identity([]),
  registerDynamicChannelSubscription: identity(noOp),
  setAnalyticsId: noOp,
  isLoggingOut: false,
  notifyLogoutStarted: noOp
});
